<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-toolbar dark color="primary pl-2 pr-2" dense>
        <v-toolbar-title>User Profile</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="exist()">
          <v-icon>cancel</v-icon>
        </v-btn>
      </v-toolbar>
    </v-col>
    <v-col cols="12" md="6" offset-md="3" class="pa-3" >
        <v-card outlined >
          <v-row no-gutters class="pl-3 pr-3">
          <v-col cols="4" md="4">
            <h4>Profile Name </h4>
          </v-col>
          <v-col cols="8" md="8">
            : {{profile.profileName}}
          </v-col>
          <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          <v-col cols="4" md="4">
            <h4>User Name </h4>
          </v-col>
          <v-col cols="8" md="8">
            : {{profile.userName}}
          </v-col>
          <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          <v-col cols="4" md="4">
            <h4>Branch</h4> 
          </v-col>
          <v-col cols="8" md="8">
            : {{profile.branchName}}
          </v-col>
          <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          <v-col cols="4" md="4">
           <h4> User Type </h4>
          </v-col>
          <v-col cols="8" md="8">
            <h4 class="red--text">: {{profile.userTypeName}}</h4>
          </v-col>
          <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          <v-col cols="4" md="4">
            <h4>Nrc </h4>
          </v-col>
          <v-col cols="8" md="8">
            : {{profile.nrcno}}
          </v-col>
          <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          <v-col cols="4" md="4">
            <h4>Phone </h4>
          </v-col>
          <v-col cols="8" md="8">
            : {{profile.phone}}
          </v-col>
          <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          <v-col cols="4" md="4">
            <h4>Address </h4>
          </v-col>
          <v-col cols="8" md="8">
            : {{profile.address}}
          </v-col>
          <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          <v-col cols="4" md="4">
            <h4>Emergency Contact </h4>
          </v-col>
          <v-col cols="8" md="8">
            : {{profile.emergencyContact}}
          </v-col>
          <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          <v-col cols="4" md="4">
            <h4>Join Date </h4>
          </v-col>
          <v-col cols="8" md="8">
            : {{profile.joinDate}}
          </v-col>
          <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          <v-col cols="4" md="4">
            <h4>Blood Group </h4>
          </v-col>
          <v-col cols="8" md="8">
            : {{profile.bloodGroup}}
          </v-col>
          <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          <v-col cols="4" md="4">
            <h4>Percent </h4>
          </v-col>
          <v-col cols="8" md="8">
            : {{profile.percent}}(%)
          </v-col>
          <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          <v-col cols="4" md="4">
            <h4>Salary </h4>
          </v-col>
          <v-col cols="8" md="8">
            : {{profile.salary|defaultPaymentFormat}}
          </v-col>
          <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          <v-col cols="4" md="4">
            <h4>Motor License </h4>
          </v-col>
          <v-col cols="8" md="8">
            : {{profile.motorLicense}}
          </v-col>
          <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          <v-col cols="4" md="4">
            <h4>Driving License </h4>
          </v-col>
          <v-col cols="8" md="8">
            : {{profile.drivingLicense}}
          </v-col>
      </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  data: () => ({
  }),
  props: {profile:Object},
  mounted: function() {
  },
  methods: {
    exist: function() {
      this.$emit("exist");
    },
  },
  watch: {},
  components: {}
};
</script>